import {
    useEffect,
    useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAuthSession
} from "../../constants/constant";
import { getFCMServiceWorkerRegistration, listenForForegroundMessages, requestFCMToken } from "../../firebase";
import { getBaseNotificationCount, setBaseFcmNotification } from "../dashboard/dashboardNetworkController";

const SnpFcmNotification = ({
    setCount,
    onNotificationMessage,
}) => {

    const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const navigate = useNavigate();
    const [serviceWorkerRegistration, setServiceWorkerRegistration] = useState(null);

    // --------------------------------------------
    // 🔵 1. REGISTER SERVICE WORKER (ONLY ONCE)
    // --------------------------------------------
    useEffect(() => {
        if ("serviceWorker" in navigator) {
            getFCMServiceWorkerRegistration()
                .then(async (registration) => {
                    setServiceWorkerRegistration(registration);
                    console.log("SW registered:", registration);
                })
                .catch((err) => console.error("SW registration failed:", err));
        }
    }, []);

    // --------------------------------------------
    // 🔵 2. SERVICE WORKER MESSAGE LISTENER (ONLY ONCE)
    // --------------------------------------------
    useEffect(() => {
        if (!("serviceWorker" in navigator)) return;

        const handler = (event) => {
            console.info("[NOTIFICATION_TRACE] SERVICE_WORKER_MESSAGE", event.data);

                // Update notification count
            getBaseNotificationCount(
                storeApiUrl.BACKEND_BASE_URL,
                storeActiveShopHash,
                (count) => setCount(count)
            );

            if (event.data?.type === "firebase-notification") {
                if (event.data.message && onNotificationMessage) {
                    onNotificationMessage(event.data.message, "firebase-background", {
                        systemNotificationShown: event.data.systemNotificationShown === true,
                    });
                }
            }

                // Navigation
            if (event.data?.type === "navigate") navigate(event.data.url);
        };

        navigator.serviceWorker.addEventListener("message", handler);

        return () => navigator.serviceWorker.removeEventListener("message", handler);
    }, [navigate, onNotificationMessage, setCount, storeActiveShopHash, storeApiUrl]);

    // --------------------------------------------
    // 🔵 3. FCM TOKEN + FOREGROUND LISTENER
    // --------------------------------------------
    useEffect(() => {
        if (!serviceWorkerRegistration) return;

        let disposed = false;
        let unsubscribe;

        (async () => {
            const token = await requestFCMToken(serviceWorkerRegistration);
            if (!token || disposed) {
                console.warn("[NOTIFICATION_TRACE] FCM_TOKEN_UNAVAILABLE", {
                    permission: typeof Notification === "undefined" ? "unsupported" : Notification.permission,
                });
                return;
            }

            console.info("[NOTIFICATION_TRACE] FCM_TOKEN_ACQUIRED", {
                token: `${token.slice(0, 4)}...${token.slice(-4)}`,
                shopHash: storeActiveShopHash?.id,
            });

            setBaseFcmNotification(
                getAuthSession().apiToken,
                storeApiUrl.BACKEND_BASE_URL,
                storeActiveShopHash,
                token,
                null
            );

            unsubscribe = await listenForForegroundMessages((payload) => {
                console.info("[NOTIFICATION_TRACE] FCM_FOREGROUND_RECEIVED", payload);

                const rawMessage = payload.data?.message;

                if (rawMessage && onNotificationMessage) {
                    onNotificationMessage(rawMessage, "firebase-foreground", { systemNotificationShown: false });
                }

                getBaseNotificationCount(
                    storeApiUrl.BACKEND_BASE_URL,
                    storeActiveShopHash,
                    (count) => setCount(count)
                );
            });

        })();

        return () => {
            disposed = true;
            if (unsubscribe) unsubscribe();
        };
    }, [serviceWorkerRegistration, onNotificationMessage, storeApiUrl, storeActiveShopHash, setCount]);

    return null;
};

export default SnpFcmNotification;
